export const getResetCodeDeliveryMessage = (deliveryMedium: unknown) => {
  if (deliveryMedium === 'EMAIL') {
    return 'Check your email for a confirmation code.';
  }

  if (deliveryMedium === 'SMS') {
    return 'Check your phone for a text message with a confirmation code.';
  }

  return 'Check your email or phone for a confirmation code.';
};
